module.exports = __webpack_public_path__ + "img/valores.88405aaf.svg";